import { withTranslation } from "react-i18next"

const LocaleSwitcher = ({ children }) => children

export default withTranslation()(LocaleSwitcher)
